/**
 * @author Ariel
 * @description 话术管理
 * @Date 2022-03-17
 */
import React from "react";
import {connect} from "dva";
import moment from "moment";
import {templateConfig,reduxTemplateConfig} from "./config";

import {framework_tool, component_tool} from '../../../tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport} = component_tool;

class VerbalTrickManager extends WizContainer {
  componentName = 'VerbalTrickManager';

  constructor(props){
    super(props);
    this.state = {
    }
  };

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '话术',
        field: 'name',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '版本号',
        field: 'version',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '标签',
        field: 'labelNames',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '发布时间',
        field: 'publishTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '有效期',
        field: 'effectiveTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否到期',
        field: 'overdue',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '适用品牌',
        field: 'orgNames',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '所属分类',
        field: 'categoryName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '上级分类',
        field: 'parentCategoryName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },

    ]
    if (o['success']) {
      let data = o['data']

      if(data && data instanceof Array && data.length>0){
        const timeTypeEnum = {1: '月', 2: '年'}
        const overdueEnum = {0: '否', 1: '是'}
        const stateEnum = {0: '禁用', 1: '启用'}
        data.forEach(p => {
          p['publishTime'] = moment(p['publishTime']).format("YYYY-MM-DD")
          p['labelNames'] = p['labelList']?.map(item => item.title).join();
          p['orgNames'] = p['orgList']?.map(item => item.name).join();
          p['effectiveTime'] = p['effectiveTime'] + timeTypeEnum[p['timeType']]
          p['overdue'] = overdueEnum[p['overdue']]
          p['state'] = stateEnum[p['state']]
        })
      }
      WizBrowserExport({
        title: '话术管理',
        sheetName: '话术管理',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '话术管理.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(VerbalTrickManager);
